import styled from 'styled-components';
import Heading from '../Heading';
const H4 = styled(Heading).attrs({
  tagName: 'h4'
}).withConfig({
  displayName: "H4"
})([""]);
H4.displayName = 'H4';
export default H4;